import svgUrl from "ni:svgr;aUfZshHRklRV6HqewXVf-2JlNKgUs9F4fZ9-Lp3fiaI";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiLocalFileSIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="var(--tbl--colors--icons--transformation--primary)" d="M3 3a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l3.414 3.414a1 1 0 0 1 .293.707V13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3Z" /><path fill="#fff" fillOpacity={0.5} d="M9 5V2l4 4h-3a1 1 0 0 1-1-1Z" /></svg>;
const Memo = memo(UiLocalFileSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiLocalFileSIcon)";
}